import React from "react"

export const HoverButton = ({href,text,isActive,onClic}) => {
    return (
        <div className={`hover-button ${isActive ? 'active' : '' }`} onClick={onClic}>
            <a className="hover-button-text" href={href}>{text}</a>
            <div className="hover-button-line"></div>
        </div>
    ) 
}